// TODO: envs should be enforced to always have a value, depending on them missing is tech debt

function asNumber(env?: string) {
  const envAsNumber = Number(env)

  if (Number.isNaN(envAsNumber)) return undefined

  return envAsNumber
}

// Only to be used on the server
const serverEnvs = {
  ADMIN_API_KEY: process.env.ADMIN_API_KEY,
  ADMIN_URL: process.env.ADMIN_URL,
  AUTHZ_URL: process.env.AUTHZ_URL,
  CORE_API_RETRIES: asNumber(process.env.CORE_API_RETRIES),
  CORE_API_RETRY_DELAY: asNumber(process.env.CORE_API_RETRY_DELAY),
  CORE_API_TIMEOUT: asNumber(process.env.CORE_API_TIMEOUT),
  DEPLOYMENT: process.env.DEPLOYMENT,
  DEV_CORE_URL: process.env.DEV_CORE_URL,
  DISABLE_CONSENT_BANNER: Boolean(process.env.DISABLE_CONSENT_BANNER),
  DISABLE_COOKIE_DOMAINS: process.env.DISABLE_COOKIE_DOMAINS,
  DISABLE_DEVICE_TOKEN: process.env.DISABLE_DEVICE_TOKEN,
  DISABLE_FEATURE_SWITCH_IN_MEMORY_CACHE: Boolean(
    process.env.DISABLE_FEATURE_SWITCH_IN_MEMORY_CACHE,
  ),
  DISABLE_FEATURE_SWITCH_REMOTE_CACHE: Boolean(process.env.DISABLE_FEATURE_SWITCH_REMOTE_CACHE),
  DISABLE_KEEP_ALIVE: Boolean(process.env.DISABLE_KEEP_ALIVE),
  DISABLE_RATE_LIMITER: Boolean(process.env.DISABLE_RATE_LIMITER),
  DISABLE_REDUCED_EXTERNAL_REQUEST_TIMEOUTS: process.env.DISABLE_REDUCED_EXTERNAL_REQUEST_TIMEOUTS,
  DISABLE_SECURE_COOKIE: Boolean(process.env.DISABLE_SECURE_COOKIE),
  ENABLE_CORE_TIMEOUT_AND_RETRY: process.env.ENABLE_CORE_TIMEOUT_AND_RETRY,
  ENABLE_OTEL: Boolean(process.env.ENABLE_OTEL),
  ENCRYPT_PEPPER: process.env.ENCRYPT_PEPPER,
  FORCE_NEXT_ONLY: process.env.FORCE_NEXT_ONLY,
  HTTP_RELAY_URL: process.env.HTTP_RELAY_URL,
  POD_IP: process.env.POD_IP,
  POD_NAME: process.env.POD_NAME,
  POD_NAMESPACE: process.env.POD_NAMESPACE,
  RATE_LIMITER_USE_CANONICAL_REQUEST_IP: Boolean(process.env.RATE_LIMITER_USE_CANONICAL_REQUEST_IP),
  RAILS_SECRET_TOKEN: process.env.RAILS_SECRET_TOKEN,
  RAILS_URL: process.env.RAILS_URL,
  REDIS_DEFAULT_CA_FILE: process.env.REDIS_DEFAULT_CA_FILE,
  REDIS_FEATURE_SWITCH_CACHE_HOST: process.env.REDIS_FEATURE_SWITCH_CACHE_HOST,
  REDIS_RATE_LIMITER_HOST: process.env.REDIS_RATE_LIMITER_HOST,
  SERVICE_NAME: process.env.SERVICE_NAME,
  SVC_ABS_URL: process.env.SVC_ABS_URL,
  API_GATEWAY_URL: process.env.API_GATEWAY_URL,
  CRM_EVENT_PROCESSOR_URL: process.env.CRM_EVENT_PROCESSOR_URL,
  SVC_VAN_URL: process.env.SVC_VAN_URL,
  OAUTH2_CLIENT_SECRET: process.env.OAUTH2_CLIENT_SECRET,
  HTTP_CLIENT_CACHE: Boolean(process.env.HTTP_CLIENT_CACHE),
  HTTP_CLIENT_DEDUPLICATION: Boolean(process.env.HTTP_CLIENT_DEDUPLICATION),
  HTTP_CLIENT_PIPELINING: asNumber(process.env.HTTP_CLIENT_PIPELINING),
  HTTP_CLIENT_RETRY_INTERCEPTOR: Boolean(process.env.HTTP_CLIENT_RETRY_INTERCEPTOR),
  OTEL_EXPORTER_OTLP_ENDPOINT: process.env.OTEL_EXPORTER_OTLP_ENDPOINT,
  SVC_PRICING_URL: process.env.SVC_PRICING_URL,
  OTEL_CLIENT_SIDE_METRICS_KEY: process.env.OTEL_CLIENT_SIDE_METRICS_KEY,
  SVC_DPP_URL: process.env.SVC_DPP_URL,
  L2_CACHE_MEMORY_DRIVER_MAX_SIZE: process.env.L2_CACHE_MEMORY_DRIVER_MAX_SIZE,
  VINTED_CONTEXT_HEADERS_ENABLED: Boolean(process.env.VINTED_CONTEXT_HEADERS_ENABLED),
}

const universalEnvs = {
  FACEBOOK_CLIENT_ID: process.env.FACEBOOK_CLIENT_ID,
  APPLE_CLIENT_ID: process.env.APPLE_CLIENT_ID,
  GOOGLE_CLIENT_ID: process.env.GOOGLE_CLIENT_ID,
  GOOGLE_MAPS_API_KEY: process.env.GOOGLE_MAPS_API_KEY,
  DATADOME_CLIENT_SIDE_KEY: process.env.DATADOME_CLIENT_SIDE_KEY,
  ONDATO_CERTIFICATE: process.env.ONDATO_CERTIFICATE,
  ONDATO_RSA_PUBLIC_KEY: process.env.ONDATO_RSA_PUBLIC_KEY,
  SHOULD_USE_BEACON_FLAG: process.env.CLIENT_METRIC_UPGRADE_FOR_SHOULD_USE_BEACON_ENABLED,
  // Tech debt cases, mapped to future values
  RELEASE_VERSION: process.env.NEXT_PUBLIC_RELEASE_VERSION,
  NEXT_JS: process.env.NEXT_PUBLIC_NEXT_JS,
  CSRF_TOKEN: process.env.NEXT_PUBLIC_CSRF_TOKEN,
  NODE_ENV: process.env.NODE_ENV,
  IMG_TAG: process.env.NEXT_PUBLIC_IMG_TAG,
  SVC_IAM_OAUTH_URL: process.env.SVC_IAM_OAUTH_URL,
}

export type UniversalEnvs = typeof universalEnvs
export type ServerEnvs = typeof serverEnvs

export { universalEnvs, serverEnvs }
